import { IPersonResponsible } from './iperson-responsible';

export interface IPersonResponsibleState {
  personResponsible: IPersonResponsible;
  personResponsibles: IPersonResponsible[];
  error?: any;
  idPerson: number;
}
